
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 18.354c-.222 0-.434-.041-.635-.125a1.873 1.873 0 01-.552-.354l-6.688-6.687a1.872 1.872 0 01-.354-.552A1.646 1.646 0 011.646 10c0-.222.042-.437.125-.646.083-.208.201-.389.354-.541l6.688-6.688c.166-.167.35-.288.552-.364a1.861 1.861 0 011.281 0c.208.076.389.198.541.364l6.688 6.688c.167.152.288.333.365.541a1.861 1.861 0 010 1.282 1.561 1.561 0 01-.365.552l-6.688 6.687c-.152.153-.333.271-.541.354a1.722 1.722 0 01-.646.125zm-.833-7.52h1.666v-5H9.167v5zm.833 2.5c.236 0 .434-.08.594-.24.16-.16.24-.358.24-.594a.806.806 0 00-.24-.594.807.807 0 00-.594-.24.806.806 0 00-.594.24.806.806 0 00-.24.594c0 .236.08.434.24.594.16.16.358.24.594.24z"}})])
          )
        }
      }
    